import { getPathTokens } from '../common/components/SearchHeader/urls/parseSearchUrl';
import {
  makeWholePath,
  parseWholePath,
} from '../common/components/SearchHeader/urls/path-segments/wholePath';
import { LoggerService } from '../common/services/LoggerService/LoggerService';

export const isRedirectNeeded = (asPath: string, logger: LoggerService) => {
  const path = getPathTokens(asPath);
  const firstRedirect = [...makeWholePath(parseWholePath(path))];

  if (path.join('/') === firstRedirect.join('/')) {
    /** We are already on the canonical path */
    return false;
  } else {
    logger?.info(`Should redirect to ${firstRedirect.join('/')}`);
  }

  const secondRedirect = [...makeWholePath(parseWholePath(firstRedirect))];

  if (firstRedirect.join('/') === secondRedirect.join('/')) {
    /** The redirect is stable */
    return true;
  } else {
    logger?.error(`Unstable redirect: ${firstRedirect.join('/')} -> ${secondRedirect.join('/')}`);
    return false;
  }
};
